import { Controller } from 'react-hook-form';
import { Keyboard, Pressable, StyleSheet, View } from 'react-native';
import { RadioButton, Text } from 'react-native-paper';
import { CheckboxOption as CropCircleCheckboxOption } from '../crop-circle/Components/CheckboxOption';
import { spacing } from '../crop-circle/tokens';
import { Colors } from '../../themes/colors';

type RadioButtonOption = {
  label?: string;
  value: any;
};

type ControlledRadioButtonProps = {
  control: any;
  name: string;
  options: RadioButtonOption[];
  horizontal?: boolean;
  color?: string;
  useCropCircle?: boolean;
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const ControlledRadioButtonsOld = ({
  control,
  name,
  options,
  horizontal = false,
  color,
}: ControlledRadioButtonProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <View
          style={horizontal ? styles.horizontalContainer : styles.container}
        >
          {options.map((option) => (
            <Pressable
              key={option.value}
              style={
                horizontal
                  ? styles.horizontalItemContainer
                  : styles.itemContainer
              }
              onPress={() => {
                Keyboard.dismiss();
                onChange(option.value);
              }}
            >
              <RadioButton.Android
                value={option.value}
                status={option.value === value ? 'checked' : 'unchecked'}
                color={color}
                onPress={() => {
                  Keyboard.dismiss();
                  onChange(option.value);
                }}
              />
              <View style={styles.labelsContainer}>
                <Text numberOfLines={8} style={styles.label}>
                  {option.label || option.value}
                </Text>
              </View>
            </Pressable>
          ))}
        </View>
      )}
    />
  );
};

// TODO: Crop Circle Redesign | Remove to ControlledRadioButtonsBase after feature is fully rolled out
const ControlledRadioButtonsBase = ({
  control,
  name,
  options,
}: ControlledRadioButtonProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <View style={stylesCropCircle.container}>
          {options.map((option) => (
            <CropCircleCheckboxOption
              key={option.value}
              mode="radio"
              state={option.value === value ? 'checked' : 'unchecked'}
              label={option.label || option.value}
              // Blur any focused text input: selecting an option ends typing, and a
              // still-focused input makes Android snap the scroll back to its cursor.
              onPress={() => {
                Keyboard.dismiss();
                onChange(option.value);
              }}
            />
          ))}
        </View>
      )}
    />
  );
};

export const ControlledRadioButtons = (props: ControlledRadioButtonProps) => {
  if (props.useCropCircle) {
    return <ControlledRadioButtonsBase {...props} />;
  }

  return <ControlledRadioButtonsOld {...props} />;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
  },
  horizontalContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  itemContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    maxHeight: 100,
    paddingRight: 16,
    marginBottom: 16,
  },
  labelsContainer: {
    flex: 1,
  },
  horizontalItemContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 16,
    width: '50%',
  },
  label: {
    fontSize: 16,
    color: Colors.black,
    fontWeight: '400',
    lineHeight: 19,
  },
});

const stylesCropCircle = StyleSheet.create({
  container: {
    gap: spacing.sm,
  },
});
